var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBackpack48Line = function SvgIconBackpack48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 12.45h-.3v-3.3h-3.6v3.3h-7v-3.3h-3.6v3.3h-.3a5.31 5.31 0 0 0-5.3 5.3v18.2c0 1.6 1.3 2.9 2.9 2.9h19.6c1.6 0 2.9-1.3 2.9-2.9v-18.2c0-2.92-2.38-5.3-5.3-5.3Zm1.9 23H14.7v-17.7c0-1.05.85-1.9 1.9-1.9h14.8c1.05 0 1.9.85 1.9 1.9v17.7Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27.3H17v3.4h10.6V33H31v-5.7Z",
    fill: "current"
  })));
};
export default SvgIconBackpack48Line;